var _rect, _rect2, _g, _rect3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnglishFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_413_1997)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666504,
    y: 0.728027,
    width: 20,
    height: 20,
    rx: 2,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_413_1997",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 21
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.666504,
    y: 0.728027,
    width: 20,
    height: 20,
    rx: 2,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_413_1997)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.666504,
    y: 0.728027,
    width: 20,
    height: 20,
    fill: "#0A17A7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-0.249568 -1.18848L8.28553 6.87132V-0.605364H13.0474V6.87132L21.5825 -1.18848L22.6477 1.02229L15.8995 7.39464H20.6665V14.0613H15.8995L22.6477 20.4336L21.5825 22.6444L13.0474 14.5846V22.0613H8.28553V14.5846L-0.249568 22.6444L-1.3147 20.4336L5.43344 14.0613H0.666481V7.39464H5.43344L-1.3147 1.02229L-0.249568 -1.18848Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0007 7.06022L23.0474 -1.27197",
    stroke: "#DB1F35",
    strokeWidth: 0.666667,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9614 14.4253L23.0713 22.0781",
    stroke: "#DB1F35",
    strokeWidth: 0.666667,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.38484 7.03857L-2.07446 -0.942871",
    stroke: "#DB1F35",
    strokeWidth: 0.666667,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.30234 14.333L-2.07446 23.0386",
    stroke: "#DB1F35",
    strokeWidth: 0.666667,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666504 12.728H9.23793V20.728H12.0951V12.728H20.6665V8.72803H12.0951V0.728027H9.23793V8.72803H0.666504V12.728Z",
    fill: "#E6273E"
  })))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1.1665,
    y: 1.22803,
    width: 19,
    height: 19,
    rx: 9.5,
    stroke: "#ECEAE6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_413_1997"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.666504,
    y: 0.728027,
    width: 20,
    height: 20,
    rx: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnglishFlag);
export default __webpack_public_path__ + "static/media/english_flag.375135a32b8d502e155b8aefe89fb59e.svg";
export { ForwardRef as ReactComponent };